import { NgModule } from '@angular/core';
import { NgSharedModule } from '@principle-theorem/ng-shared';
import { RomexisV2OpenPatientComponent } from './romexis-v2-open-patient/romexis-v2-open-patient.component';
import { RomexisV2FeatureService } from './romexis-v2-feature.service';

@NgModule({
  declarations: [RomexisV2OpenPatientComponent],
  imports: [NgSharedModule],
  providers: [RomexisV2FeatureService],
})
export class RomexisV2Module {}
